// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    Avatar, Button, Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";


// App Imports
import Box from "@mui/material/Box";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";


// main function
export default function CopyContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    return (

        <Box>
            {(rowContractData.contractLevel === "X") &&
                <MenuItem>
                            <ListItemIcon>
                                <ContentCopyIcon fontSize="small"/>
                            </ListItemIcon>
                            <ListItemText>Copy</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
